import { useTranslation } from "react-i18next";
import { CardV2 } from "../../../components/CardV2/CardV2";
import { LabelV2 } from "../../../components/LabelV2/LabelV2";
import Switch from "../../../components/Switch/Switch";
import PrimaryButton from "../../../components/PrimaryButton/PrimaryButton";
import { ExternalLink } from "lucide-react";
import ContractLinkSection from "./ContractLinkSection";

interface GeneralSectionProps {
  contractTemplate: any;
  contractLink: string;
  contractLinkText: string;
  setContractLinkText: (text: string) => void;
  isUpdatingEnabled: boolean;
  onEnabledStatusChange: (enabled: boolean) => void;
}

export default function GeneralSection({
  contractTemplate,
  contractLink,
  contractLinkText,
  setContractLinkText,
  isUpdatingEnabled,
  onEnabledStatusChange,
}: GeneralSectionProps) {
  const { t } = useTranslation();

  return (
    <CardV2>
      <div className="p-4">
        {/* Enable/Disable Commission Contracts Switch */}
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <div>
              <LabelV2 htmlFor="commission-enabled">
                {t("commission_settings_page.enable_contracts") || "Enable Commission Contracts"}
              </LabelV2>
              <p className="text-sm text-gray-600 mt-1">
                {t("commission_settings_page.enable_contracts_description") || "Allow customers to submit commission contract applications through your public link"}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Switch
                checked={contractTemplate.enabled ?? true}
                onChange={() => onEnabledStatusChange(!contractTemplate.enabled)}
                disabled={isUpdatingEnabled}
              />
              {isUpdatingEnabled && (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
              )}
            </div>
          </div>
        </div>

        <ContractLinkSection
          contractLink={contractLink}
          contractLinkText={contractLinkText}
          setContractLinkText={setContractLinkText}
        />
        <div className="flex justify-end mt-4">
          <a
            href={contractLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <PrimaryButton
              text={
                <span className="flex items-center gap-2">
                  {t("commission_contract_template.button.see_contract") || "See request form page"}
                  <ExternalLink className="w-4 h-4" />
                </span>
              }
              fn={() => {}}
            />
          </a>
        </div>
      </div>
    </CardV2>
  );
}
